/* Gemstone Well — footer link groups: collapsible on phones (≤860px), always open as columns on larger screens.
   Markup ships with every group open, so the links stay visible if this script never runs. */
(function(){
const groups=[...document.querySelectorAll('.foot .fcol, .bw .fcol')];if(!groups.length)return;
const mq=matchMedia('(max-width:860px)');
const apply=()=>groups.forEach((d)=>{d.open=!mq.matches;});
groups.forEach((d)=>d.querySelector('summary').addEventListener('click',(e)=>{
  if(!mq.matches){e.preventDefault();return;} // columns can't be collapsed on desktop
  if(!d.open)groups.forEach((o)=>{if(o!==d)o.open=false;}); // one group open at a time keeps the footer short
}));
apply();
mq.addEventListener?mq.addEventListener('change',apply):mq.addListener(apply);
})();
